import { useSelector } from 'react-redux';
import { MasterFileReportsInfo } from '../../models';
import { selectComplianceCentralMasterFileReportsInfo } from '../../selectors';

export const useMasterFileReportsInfo = (): MasterFileReportsInfo[] | null => {
  const masterFileReportsInfo = useSelector(selectComplianceCentralMasterFileReportsInfo);

  return masterFileReportsInfo;
};
